import { render, staticRenderFns } from "./SummaryModal.vue?vue&type=template&id=65923774&scoped=true&"
import script from "./SummaryModal.vue?vue&type=script&lang=js&"
export * from "./SummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./SummaryModal.vue?vue&type=style&index=0&id=65923774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65923774",
  null
  
)

export default component.exports